<div class="w-full lg:max-w-7xl p-8">
    <div class="prose prose-sm !max-w-100">
        <h2>{{ 'label_pending_tax_updates' | transloco }}</h2>
        <h3>{{ 'info_pending_tax_updates' | transloco }}</h3>
    </div>
    <mat-divider class="my-4"></mat-divider>

    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
        <mat-form-field class="fuse-mat-no-subscript w-full sm:w-80">
            <mat-label>Kennitala</mat-label>
            <input
                matInput
                [formControl]="ssnSearchControl"
                maxlength="11"
                inputmode="numeric"
                pattern="[0-9]{6}-?[0-9]{4}"
                (input)="formatSsn()"
                (keydown.enter)="search()"
                autocomplete="off"
            />
        </mat-form-field>
        <button mat-flat-button color="primary" type="button" (click)="search()">
            <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
            <span class="ml-2">Leita</span>
        </button>
    </div>

    @if (isLoading) {
        <div class="flex flex-col items-center justify-center py-16">
            <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
        </div>
    } @else {
        @if (searchedSsn) {
            <div class="mt-4 mb-2 text-base font-medium">Niðurstöður fyrir kennitölu {{ searchedSsn }}</div>
        }
        <div class="flex flex-wrap -m-2 mt-4 justify-center">
            <table mat-table matSort [dataSource]="dataSource" class="w-full table-expandable">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Númer</th>
                    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container>
                <ng-container matColumnDef="ssn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Kennitala</th>
                    <td mat-cell *matCellDef="let element">{{ formatSsnValue(element.ssn) }}</td>
                </ng-container>
                <ng-container matColumnDef="taxUpdateType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Tegund uppfærslu</th>
                    <td mat-cell *matCellDef="let element">{{ getTaxUpdateTypeLabel(element.taxUpdateType) }}</td>
                </ng-container>
                <ng-container matColumnDef="newValue">
                    <th mat-header-cell *matHeaderCellDef>Nýtt gildi</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.taxUpdateType === 'TaxBracket') {
                            {{ getTaxBracketLabel(element.taxBracket, element.salaryOther) }}
                        } @else {
                            <div>Nýting persónuafsláttar: {{ element.taxCreditPercentage }}%</div>
                            <div>Gildir frá: {{ element.taxCreditValidFrom | date: 'dd.MM.yyyy' }}</div>
                            @if (element.taxCreditValidTo) {
                                <div>Gildir til: {{ element.taxCreditValidTo | date: 'dd.MM.yyyy' }}</div>
                            }
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Stofnað þann</th>
                    <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
            </table>
        </div>
    }
</div>
